import Vue from 'vue'
import App from './App.vue'
import router from './router';
import ElementUI from 'element-ui';
import '@/utils/register'
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss' //自定义全局css
// 全局通用方法
import { newPage, copyToClipboard, goBack, handleClose } from './utils/common'
Vue.prototype.$newPage = newPage;
Vue.prototype.$copy = copyToClipboard;
Vue.prototype.$goBack = goBack;
Vue.prototype.$handleClose = handleClose;

Vue.config.productionTip = false
Vue.use(ElementUI);



new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
